import { render, staticRenderFns } from "./ReceitaDetalhes.vue?vue&type=template&id=ec17c3a2"
import script from "./ReceitaDetalhes.vue?vue&type=script&lang=js"
export * from "./ReceitaDetalhes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports